// Basics every company gets, plus add-on features they tick. A company with no saved list has everything.
export const BASICS = "Timesheets, payroll and rosters (with leave requests)";
export const MODULES = [
  { key: "jobs", short: "jobs", label: "Jobs & proof of work", desc: "Send jobs to your crew with site photos, notes, presets and branded job reports." },
  { key: "clients", short: "clients", label: "Client list", desc: "Keep client details in one place and link them to jobs." },
  { key: "invoices", short: "invoices", label: "Client invoices & payments", desc: "Invoice clients, take card or bank payments, chase overdue and send statements.", needs: "clients" },
];
const ALL = MODULES.map((m) => m.key);

export const modulesOf = (company) => (Array.isArray(company?.modules) ? company.modules : ALL);
export const hasModule = (company, key) => !key || modulesOf(company).includes(key);

// Tick/untick one feature, keeping what it needs (invoices need the client list).
export const toggleModule = (list, key, on) => {
  const next = new Set(list);
  if (on) { next.add(key); const need = MODULES.find((m) => m.key === key)?.needs; if (need) next.add(need); }
  else { next.delete(key); MODULES.filter((m) => m.needs === key).forEach((m) => next.delete(m.key)); }
  return ALL.filter((k) => next.has(k));
};

export const modulesSummary = (list) => (list.length
  ? `Timesheets + ${list.map((k) => MODULES.find((m) => m.key === k)?.short).join(", ")}`
  : "Timesheets only");
